<template>
  <div class="upcoming-maintenance bg-white rounded-lg shadow-sm p-4">
    <h3 class="text-lg font-semibold mb-4 flex items-center">
      <span class="text-yellow-600 mr-2">⏰</span>
      Upcoming Maintenance (Next 30 Days)
    </h3>

    <div v-if="loading" class="text-center py-4">
      <LoadingSpinner class="mx-auto" size="sm" />
    </div>

    <div v-else-if="upcoming.length === 0" class="text-center py-6 text-gray-500">
      <p>No upcoming maintenance scheduled</p>
    </div>

    <div v-else class="space-y-3">
      <div v-for="item in upcoming" :key="item.id" 
           class="border-l-4 border-yellow-400 pl-3 py-2">
        <div class="flex justify-between items-start">
          <div>
            <p class="font-medium text-sm">{{ item.description }}</p>
            <p class="text-xs text-gray-600">{{ item.equipment?.name }}</p>
          </div>
          <span class="text-xs text-gray-500 whitespace-nowrap">
            {{ formatDate(item.maintenance_date) }}
          </span>
        </div>
        <p v-if="item.technician" class="text-xs text-gray-600 mt-1">
          Tech: {{ item.technician }}
        </p>
      </div>
    </div>

    <button @click="$emit('view-all')" class="btn-secondary w-full mt-4 text-sm">
      View All Maintenance
    </button>
  </div>
</template>

<script setup lang="ts">
import { onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useMaintenanceStore } from '@/stores/maintenanceStore';
import LoadingSpinner from '@/components/shared/LoadingSpinner.vue';

const maintenanceStore = useMaintenanceStore();
const { upcoming, loading } = storeToRefs(maintenanceStore);

defineEmits<{
  (e: 'view-all'): void;
}>();

onMounted(() => {
  maintenanceStore.fetchUpcoming(30);
});

const formatDate = (dateString: string) => {
  return new Date(dateString).toLocaleDateString();
};
</script>